import React from "react"
import { useTranslation } from "react-i18next"

import { HStack } from "@/nzds/layout"

import { ComplianceIcon } from "../compliance-icon"
import type { ComplianceStatusProps } from "./compliance-status.types"

export const ComplianceStatus: React.FC<ComplianceStatusProps> = ({
  isCompliant,
}) => {
  const { t } = useTranslation()

  const computeComplianceStatus = React.useCallback(
    (isCompliantStatus: boolean | null): string => {
      if (isCompliantStatus === null) {
        return "--"
      }

      return isCompliantStatus
        ? t("compliance.status.compliant", { ns: "sites" })
        : t("compliance.status.nonCompliant", { ns: "sites" })
    },
    [t]
  )

  return (
    <HStack sx={{ alignItems: "center", gap: 0.5 }}>
      <ComplianceIcon isCompliant={isCompliant} />
      {computeComplianceStatus(isCompliant)}
    </HStack>
  )
}
